(function ($) {
    $(window).on('load', function () {
        if ($('.publications-slider').length > 0) {
            setTimeout(function () {
                $(".publications-slider .slider").css({"opacity": "1"});
            }, 500);
        }
        $("#publications .slider .col-wrap").unwrap().unwrap().unwrap().unwrap().unwrap();

        setTimeout(function () {
            $('.publications-slider').each(function() {
                const $slider = $(this).find('.slider');
                const $slides = $slider.find('.col-wrap');

                if ($slides.length > 1) {
                    $slider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        infinite: true,
                        cssEase: 'linear',
                        autoplay: true,
                        autoplaySpeed: 2000,
                    });
                }
            });
        }, 200);
    });

})(jQuery);
